import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useSpring, animated } from '@react-spring/web';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';

import logo from '../../data/images/ballImg.png';
import img_01 from '../../data/icons/main_07.png';

type Props = {}

const TopBox = (props: Props) => {

    const theme = useTheme();

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const springs1 = useSpring({
        from: { background: '#308cff', y: -70, x: 750 },
        to: [
            { x: -100, background: '#308cff' },
            { y: 170, background: '#308cff' },
            { x: 750, background: '#308cff' },
            { y: -70, background: '#308cff' },
        ],
        loop: true,
      });

      const springs2 = useSpring({
        from: { background: '#308cff', y: -70, x: 280 },
        to: [
            { x: 0, background: '#308cff' },
            { y: 280, background: '#308cff' },
            { x: 280, background: '#308cff' },
            { y: -70, background: '#308cff' },
        ],
        loop: true,
      });


    // 상단 블록에 해당
    const GridItemHeadlineBlock = () => (
        <Box mt={10}  sx={{ zIndex: 5 }}>
            {windowWidth > 1300 ? 
                <animated.div
                style={{
                width: 0,
                height: 0,
                borderRadius: 0,
                ...springs1,
                // border: '1px solid yellow',
                }}
                >
                    {/* <SportsSoccerIcon style={{ fontSize: 64 }} sx={{ color: 'black', ml: -1, mt: -1 }}/> */}
                    <img src={logo} style={{ width: '100px' }} />
                </animated.div>
                :
                <animated.div
                        style={{
                        width: 0,
                        height: 0,
                        borderRadius: 0,
                        ...springs2,
                        // border: '1px solid yellow',
                        }}
                    >
                        {/* <SportsSoccerIcon style={{ fontSize: 64 }} sx={{ color: 'black', ml: -1, mt: -1 }}/> */}
                        <img src={logo} style={{ width: '100px' }} />
                </animated.div>
            }
        <Typography
            variant="h3"
            align={'center'}
            gutterBottom
            sx={{
            fontFamily: 'Poppins',
            fontSize: '64px',
            letterSpacing: '-3px',
            fontWeight: 900,
            '@media (max-width: 1300px)': {
                fontSize: '64px'
            }
            }}
        >
            We are Gonjiam Yonsei FC.
        </Typography>
        <Typography
            // color="text.secondary"
            align={'center'}
            sx={{
            fontFamily: 'Poppins',
            fontSize: '50px',
            letterSpacing: '-3px',
            fontWeight: 900,
            '@media (max-width: 1300px)': {
                fontSize: '50px'
            }
            }}
        >
            No pain, No gain.
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <img src={img_01} width={'280px'} />
        </Box>
        </Box>
    );

    // logos
    const GridItemPartnersBlock = () => (
        <Box display="flex" flexWrap="wrap" justifyContent={'center'} width={1} height={'350px'}>
        {[
            // 'https://assets.maccarianagency.com/svg/logos/airbnb-original.svg',
            // 'https://assets.maccarianagency.com/svg/logos/amazon-original.svg',
            // 'https://assets.maccarianagency.com/svg/logos/fitbit-original.svg',
            // 'https://assets.maccarianagency.com/svg/logos/netflix-original.svg',
            // 'https://assets.maccarianagency.com/svg/logos/google-original.svg',
            // 'https://assets.maccarianagency.com/svg/logos/paypal-original.svg',
        ].map((item, i) => (
            <Box maxWidth={80} width={1} marginTop={2} marginRight={4} key={i}>
            <Box
                component="img"
                height={1}
                width={1}
                src={item}
                alt="..."
                sx={{
                filter:
                    theme.palette.mode === 'dark'
                    ? 'brightness(0) invert(0.7)'
                    : 'contrast(0) brightness(0)',
                }}
            />
            </Box>
        ))}
        </Box>
    );


    return (
            <Box>
            <Grid container spacing={0} height={'67vh'}>
                <Grid item xs={12}>
                <Box
                    width="100%"
                    height="100%"
                    display="flex"
                    justifyContent={'center'}
                >
                    <GridItemHeadlineBlock />
                </Box>
                </Grid>
                <Grid item xs={12}>
                <Box
                    width="100%"
                    height="100%"
                    display="flex"
                    justifyContent={'center'}
                >
                    <GridItemPartnersBlock />
                </Box>
                </Grid>
            </Grid>
            </Box>
    )
}

export default TopBox